import React, {useState, ReactNode} from "react";
import {
  faChevronDown,
  faChevronUp
} from '../../components/Icons/Icons'


export interface ExpandableProps {
    isOpen: boolean;
    title: string;
    children?: ReactNode

}

function Expandable({ isOpen, title, children }: ExpandableProps) {
    const [isExpanded, setIsExpanded] = useState(isOpen);

    const toggleContent = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <div className="expandable-content">
            <div className="expandable-header" onClick={toggleContent}>
                <p className="toastie-text">{title}</p>
                <span className="icon chevron-icon">
                    {isExpanded ? faChevronUp() : faChevronDown()}
                </span>
            </div>
            {isExpanded && <div className="expandable-body">{children}</div>}
        </div>
    );
}

export default Expandable;
